<template>
	<div class="w-commonList">
		<ul class="w-tabul" v-if="List.length>0">
			<li v-for="(v,i) in List" :key="i">
				<div class="w-a flex hs vc" @click="toDetail(v.id)">
					<p class="dian shrink0"></p>
					<p class="w-text ellipsis">{{v.con}}</p>
				</div>
			</li>
		</ul>
		<div v-else>暂无</div>
	</div>
</template>

<script>
	export default {
		name: "commonList",
		props: {
			List: {
				type: Array,
				default: () => []
			},

		},

		created() {
		},
		mounted() {},
		methods: {
			toDetail(id) {
				console.log("detailId=", id)
				this.$emit('sendId', id)
			},

		}
	}
</script>


<style scoped>
	/* li */
	.w-tabul {
		margin-bottom: 30px;
		box-sizing: border-box;
		min-height: 24.5vh;
	}

	.w-tabul .w-a {
		padding: 18px 0;
		border-bottom: 1PX dotted #999;
		font-size: 16px;
		color: #333333;
		padding-left: 9px;
		box-sizing: border-box;
		cursor: pointer;
	}

	.w-tabul .dian {
		width: 6px;
		height: 6px;
		background: rgba(102, 102, 102, 1);
		border-radius: 50%;
		margin-right: 13px;
	}

	.w-text {
		width: 90%;
	}
</style>




// WEBPACK FOOTER //
// src/components/common/commonList.vue